import "./slider.css"
import image1 from "./../../../assets/slider1.jpg"
import image3 from "./../../../assets/slider3.jpg"
import image4 from "./../../../assets/slider4.jpg"
import image5 from "./../../../assets/slider5.jpg"
import image6 from "./../../../assets/slider6.jpg"
import { useState } from "react"
import {ReactComponent as LeftButton} from './../../../assets/left.svg';
import {ReactComponent as RightButton} from './../../../assets/right.svg';

export default function Slider () {
    const [index, setIndex] = useState(0)

    const imagesArray = [image1, image3,image4,image5, image6]
    
    const increaseIndex = () => {
        const newIndex = index + 1;
        if (newIndex < imagesArray.length) {
            setIndex(newIndex)
        } else setIndex(0)
    }
        let timerId = setTimeout(function tick() {
            increaseIndex()
            clearTimeout(timerId)
            timerId = setTimeout(tick, 5000); // (*)
        }, 5000);
    

    
    return (
        <span className="slider">
            <LeftButton
                className="left-button"
                onClick={
                    () => {
                        const newIndex = index - 1;
                        if (newIndex >= 0) {
                            setIndex(newIndex)
                        } else setIndex(imagesArray.length - 1) 
                    }
                }
            />
            <img className="slide" src={imagesArray[index]} alt=""/>
            <RightButton
                className="right-button"
                onClick={increaseIndex}
            />
        </span>
    )
}